import { stateOptions } from '../commonStateTaxData';

export const basicInfoQuestions = [
  {
    id: 'employee_name',
    title: 'Full name',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'employee_ssn',
    title: 'Social Security number',
    is_required: true,
    placeholder: '9 digits',
    question_type: 'identity',
    identity_type: 'ssn',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{9}$',
      },
    ],
  },
  {
    id: 'street_address',
    title: 'Home address',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'city_or_town',
    title: 'City or town',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'state',
    title: 'State',
    is_required: true,
    question_type: 'dropdown',
    options: stateOptions,
  },
  {
    id: 'zip_code',
    title: 'Zip code',
    is_required: true,
    question_type: 'short_text',
    placeholder: '5 digits',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{5}$',
      },
    ],
  },
];

export const withholdingExemptionQuestions = [
  {
    id: 'personal_exemptions',
    title: 'Your personal exemption',
    is_required: false,
    question_type: 'long_multiple_choice',
    options: [
      {
        codeValue: 'for_self',
        shortName: 'For yourself',
      },
      {
        codeValue: 'self_age_65',
        shortName: 'If you are age 65 or over or will be before next year',
      },
    ],
  },
  {
    id: 'spouse_exemptions',
    title: 'Your spouse',
    is_required: false,
    question_type: 'long_multiple_choice',
    options: [
      {
        codeValue: 'married',
        shortName: 'If married and if exemption for spouse is allowed',
      },
      {
        codeValue: 'spouse_age_65',
        shortName: 'If your spouse is age 65 or over or will be before next year and if otherwise qualified',
      },
    ],
  },
  {
    id: 'dependents',
    title: 'Enter the number of your qualified dependents',
    is_required: true,
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^[0-9]+(.[0-9]{1,2})?$',
      },
      {
        value: '100',
        action: 'lte',
        category: 'number',
      },
    ],
  },
  {
    id: 'additional_withholding',
    title: 'Additional withholding per pay period under agreement with employer',
    is_required: false,
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^[0-9]+(.[0-9]{1,2})?$',
      },
    ],
  },
];

export const filingStatusQuestion = [
  {
    id: 'filing_status',
    title: 'Check all that apply:',
    is_required: false,
    question_type: 'long_multiple_selection',
    options: [
      {
        codeValue: 'head_of_household',
        shortName: 'If you will file as head of household on your tax return',
      },
      {
        codeValue: 'self_blind',
        shortName: 'If you are blind',
      },
      {
        codeValue: 'spouse_blind',
        shortName: 'If spouse is blind and not subject to withholding',
      },
      {
        codeValue: 'full_time_student',
        shortName:
          'If you are a full-time student engaged in seasonal, part-time or temporary employment whose estimated annual income will not exceed $8,000',
      },
    ],
  },
];
